/* eslint-disable react/prop-types */
import { Button, Form, InputNumber, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { ModalCloseBox } from '../../employees/EmployeesStyle';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';
import { FieldBox, FlexWrapper } from '../../../theme/common_style';
import { DropdownIconNew, ModalCloseIcon } from '../../../theme/SvgIcons';
import { updateProjectBillingDataApi } from '../../../redux/project/apiRoute';

const BillingModal = ({ open, onClose, selectedBillingEmp, options, assigneedEmps, reload }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const values = form.getFieldsValue();
      let payload = {
        billing_id: values.billing_id || '',
        weekly_billing_limit: values.weekly_billing_limit || 0,
        employee_id: selectedBillingEmp?.emp_id
      };

      const FilterData = assigneedEmps?.filter(
        (emp) => emp?.employee_id !== selectedBillingEmp?.emp_id
      );

      let res = await updateProjectBillingDataApi(selectedBillingEmp?.project_id, {
        billing_data: [...FilterData, payload]
      });

      if (res?.statusCode === 200) {
        toast.success('Billing ID updated successfully');
        reload();
      } else {
        throw new Error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  useEffect(() => {
    if (selectedBillingEmp) {
      form.setFieldsValue({
        billing_id: selectedBillingEmp?.billing_id || null,
        weekly_billing_limit: selectedBillingEmp?.weekly_billing_limit || ''
      });
    } else {
      form.setFieldsValue({
        weekly_billing_limit: 40
      });
    }
  }, [selectedBillingEmp, form]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      prefixCls="create-employees"
      width={422}
      centered
      closeIcon={false}
      footer={null}>
      <ModalCloseBox onClick={onClose}>
        <ModalCloseIcon />
      </ModalCloseBox>
      <ContentBox>
        <h4>Assignee Billing ID</h4>

        <Form form={form} onFinish={handleSubmit}>
          <>
            <FieldBox>
              <label htmlFor="billing_id">Billing ID</label>
              <Form.Item name="billing_id" type="text">
                <Select
                  allowClear
                  prefixCls="form-select"
                  suffixIcon={<DropdownIconNew />}
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="--Select Option--"
                  options={options?.map((option) => ({
                    label: option.name,
                    value: option.id
                  }))}
                />
              </Form.Item>
            </FieldBox>
            <FieldBox>
              <label htmlFor="billing_id">Weekly Billing Hours</label>
              <Form.Item name="weekly_billing_limit" type="text">
                <InputNumber
                  style={{ width: '100%' }}
                  prefixCls="form-input-number"
                  placeholder="Enter Weekly Limit"
                  maxLength={3}
                  min={0}
                />
              </Form.Item>
            </FieldBox>
            <FlexWrapper justify="end" style={{ marginTop: 20 }}>
              <Button
                loading={loading}
                onClick={() => form.submit()}
                style={{ width: 140 }}
                prefixCls="antCustomBtn">
                Save
              </Button>
            </FlexWrapper>
          </>
        </Form>
      </ContentBox>
    </Modal>
  );
};

export default BillingModal;

const ContentBox = styled.div`
  width: 100%;
  padding: 24px;

  h4 {
    font-family: 'Plus Jakarta Sans';
    font-weight: 700;
    font-size: 24px;
    color: #0e0e0e;
    margin: 0;
    text-align: center;
  }
`;
